import request from '@apps-common/js-client/api/request';
import {ANIMATIONS_API_URL} from '../config.js';
import {ASPECT_RATIO, STORY_WIDTH} from '../constants.js';

export const getStories = params => {
  return request.get(ANIMATIONS_API_URL, {params}).then(res => res.data);
};

export const getStory = storyId =>
  request.get(`${ANIMATIONS_API_URL}/${storyId}`).then(res => res.data);

export const createStoryRequest = ({
  title,
  description,
  isPublic,
  zoom,
  frames,
  center,
  settings,
}) => {
  return request
    .post(ANIMATIONS_API_URL, {
      title,
      description,
      width: STORY_WIDTH,
      height: STORY_WIDTH / ASPECT_RATIO,
      center: center,
      zoom,
      frames: frames.map(frame => ({
        date: frame.acquired,
        images: frame.features
          ? frame.features.map(feature => ({
              id: feature.id,
              type: feature.properties.item_type,
            }))
          : [
              {
                id: frame.name,
                type: 'Basemap',
              },
            ],
      })),
      format: settings.compare ? 'raw' : 'mp4',
      rate: settings.frameRate,
      label: settings.compare ? false : settings.labels,
      logo: !settings.compare && settings.logo,
      public: isPublic,
    })
    .then(res => res.data);
};

export const deleteStory = storyId =>
  request.delete(`${ANIMATIONS_API_URL}/${storyId}`).then(res => res.data);
